import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS, ApiEndpoints, ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExploreService {
  constructor(
    private apiCilent: ApiCilent,
    @Inject(API_ENDPOINTS)
    private readonly endpoints: ApiEndpoints,
  ) {}

  getEmsExplore(value: any): Observable<ApiResponse<any>> {
    const endpoint = this.endpoints.explore.getEmsExplore;
    return this.apiCilent.get({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      query: value,
    });
  }

  getExploreByMeter(body: any): Observable<ApiResponse<any>> {
    const endpoint = this.endpoints.explore.getExploreByMeter;
    return this.apiCilent.post({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      body,
    });
  }

  getParameterExplore(body: any): Observable<ApiResponse<any>> {
    const endpoint = this.endpoints.explore.getExploreByParam;
    return this.apiCilent.post({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      body,
    });
  }
}
